export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  const segments = token.split(".")
  if (segments.length !== 3 || !segments[1]) {
    return null
  }
  const segment = segments[1]
  try {
    const base64 = segment.replace(/-/g, "+").replace(/_/g, "/")
    const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0))
    const payload: unknown = JSON.parse(new TextDecoder().decode(bytes))
    return payload && typeof payload === "object" ? (payload as Record<string, unknown>) : null
  } catch {
    return null
  }
}

export function tokenExpired(token: string): boolean {
  const exp = decodeJwtPayload(token)?.exp
  return typeof exp !== "number" || exp * 1000 <= Date.now()
}
